import { Col, Row, Tabs } from 'antd';
import CustomerToWorker from 'components/forms/surveyTables/CustomerToWorker';

export default function SurveyWorker() {
  return (
    <Row>
      <Col span={24}>
        <Tabs
          tabPosition='left'
          defaultActiveKey={'1'}
          className='vertical-tabs'
          items={[
            {
              label: `مشتری به نیرو`,
              key: '4',
              children: <CustomerToWorker type='worker' />,
            },
          ]}
        />
      </Col>
    </Row>
  );
}
